<template>
  <img
    v-if="item"
    :src="itemToImageMapper(item)"
    :class="$style.itemImage"
    alt="">
  <div
    v-else
    class="no-item-placeholder"
  />
</template>

<script>

import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({
  name: 'ItemPreview',
})
export default class extends Vue {
  @Prop({
    type:     Object,
    required: false,
  })
  item;

  @Prop({
    type:     Function,
    required: true,
  })
  itemToImageMapper;
}
</script>

<style module>
@import "~@/style/variables.scss";

.itemImage {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/*
  So to remove a border for images that do not have src
  https://stackoverflow.com/questions/10441362/how-can-i-remove-the-border-around-an-image-without-a-source
*/

.itemImage:not([src]) {
  display: none;
}

</style>



// WEBPACK FOOTER //
// src/apps/configurator/components/Preview/ItemPreview.vue